module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container",
    class: {
      dragging: _vm.dragging
    }
  }, [_c('div', {
    staticClass: "modal",
    class: {
      showModal: _vm.showModal
    },
    attrs: {
      "id": "myModal"
    }
  }, [_c('div', {
    staticClass: "uploadcare--dialog",
    staticStyle: {
      "opacity": "1"
    }
  }, [_c('div', {
    staticClass: "uploadcare--dialog__container"
  }, [_c('div', {
    staticClass: "uploadcare--panel uploadcare--dialog__panel"
  }, [_c('h2', {
    staticClass: "uploadcare--text"
  }, [_vm._v("Choose a reason")]), _vm._v(" "), _c('button', {
    staticClass: "close uploadcare--button uploadcare--button_icon uploadcare--button_muted uploadcare--dialog__close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    },
    on: {
      "click": function($event) {
        _vm.showModal = false
      }
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex"
  }, [_c('ul', {
    staticClass: "list-unstyled reasons-list"
  }, _vm._l((_vm.recommendedReasons), function(reason) {
    return _c('li', {
      staticClass: "lead"
    }, [_c('a', {
      attrs: {
        "href": "#",
        "data-dismiss": "modal"
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          _vm.setReasonFromModal(reason.reason)
        }
      }
    }, [_vm._v(_vm._s(reason.reason))])])
  }))])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "myModal",
      "tabindex": "-1",
      "role": "dialog",
      "aria-labelledby": "myModalLabel"
    }
  }), _vm._v(" "), _c('div', {}, [_c('div', {}, [_c('div', {}, [_c('h2', {
    staticClass: "text-center"
  }, [_vm._v("\n          " + _vm._s(_vm.header) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "lead intro-text mb-5",
    domProps: {
      "innerHTML": _vm._s(_vm.copy)
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-4  mb-4"
  }, [_c('h4', {
    staticClass: "mb-1"
  }, [_vm._t("step-1-text")], 2), _vm._v(" "), _vm._t("step-1"), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary mt-2",
    attrs: {
      "type": "button",
      "id": "file",
      "name": "file"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openUploadCare()
      }
    }
  }, [_vm._t("step-1-button-text")], 2), _vm._v(" "), _c('input', {
    attrs: {
      "type": "hidden",
      "role": "uploadcare-uploader",
      "name": "my_file"
    }
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-4  mb-4"
  }, [_c('h4', {
    staticClass: "mb-1"
  }, [_vm._t("step-2-text")], 2), _vm._v(" "), _vm._t("step-2"), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "mt-1 mb-2 form-control",
    attrs: {
      "maxlength": "80",
      "rows": "3",
      "name": "name",
      "placeholder": _vm.buttontwoplaceholder
    },
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": [function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }, _vm.redraw],
      "propertychange": function($event) {
        _vm.changeText()
      }
    }
  }), _vm._v(" "), _c('div', {}, [_c('button', {
    staticClass: "btn btn-secondary",
    attrs: {
      "type": "button",
      "data-toggle": "modal",
      "data-target": "#myModal"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openModal()
      }
    }
  }, [_vm._t("step-2-button-text")], 2)])], 2), _vm._v(" "), _c('div', {
    staticClass: "col-md-4 mb-4"
  }, [_c('h4', {
    staticClass: "mb-1"
  }, [_vm._t("step-3-text")], 2), _vm._v(" "), _vm._t("step-3"), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    staticClass: "mt-1 mb-2 form-control",
    attrs: {
      "type": "email",
      "name": "email"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })], 2)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade"
    }
  }, [(_vm.showZoom) ? _c('div', {
    staticClass: "zoom mb-2"
  }, [_c('div', {}, [_c('span', [_vm._v("Zoom")]), _vm._v(" "), _c('div', {
    staticClass: "d-inline-block zoom-range-container"
  }, [_c('input', {
    attrs: {
      "type": "range",
      "value": "1",
      "min": _vm.zoomBounds.min,
      "max": _vm.zoomBounds.max,
      "step": "0.01"
    },
    on: {
      "input": function($event) {
        _vm.setZoom($event)
      },
      "change": function($event) {
        _vm.setZoom($event)
      }
    }
  })])])]) : _vm._e()]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "generatorCanvas"
    }
  }), _vm._v(" "), _c('div', {}, [(!_vm.openShareMenu) ? _c('button', {
    staticClass: "btn btn-primary mt-3 ",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.uploadAndShare($event)
      }
    }
  }, [(!_vm.uploading) ? _c('span', [_vm._v(_vm._s(_vm.buttonText))]) : _c('span', [_c('i', {
    staticClass: "fa fa-spinner spinner fa-pulse"
  })])]) : _c('div', {
    staticClass: "upload-and-share-container mt-3"
  }, [_c('a', {
    staticClass: "btn btn-secondary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.facebookShare($event)
      }
    }
  }, [_vm._m(0)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-secondary",
    attrs: {
      "href": _vm.twitterShareUrl,
      "target": "_blank"
    },
    on: {
      "click": _vm.gaTwitterEvent
    }
  }, [_vm._m(1)]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('a', {
    staticClass: "btn btn-secondary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": [function($event) {
        $event.preventDefault();
        _vm.downloadImage($event)
      }, _vm.gaDownloadEvent]
    }
  }, [_c('div', {}, [_vm._v("\n              Download Image\n            ")])])])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_vm._v("\n              Share on\n              "), _c('i', {
    staticClass: "fa fa-facebook"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {}, [_vm._v("\n              Share on\n              "), _c('i', {
    staticClass: "fa fa-twitter"
  })])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-542602e4", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-542602e4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/generator.vue
// module id = 138
// module chunks = 0